/**
 * Common messages used for notifications and error handling.
 */

export default {
  NETWORK_ERROR: 'We are experiencing network issues. Please try again.',
};
